import React from 'react';

import { FaInstagram } from 'react-icons/fa';
import { MdOutlineAlternateEmail } from 'react-icons/md';

import { SITE_EMAIL } from 'constant';

import {
  List,
  ListItem,
  ListItemLink
} from './ReportErrorContact.styles';

interface ReportErrorContactProps {
  showContact?: boolean;
}

const ReportErrorContact = ({ showContact = false }: ReportErrorContactProps) => {
  return (
    <List color="black">

        {
          showContact ? (
            <ListItem color="black">
              <ListItemLink to="https://www.instagram.com/bells80120/" target="_blank">
                <FaInstagram /> <span>BELLS80120</span>
              </ListItemLink>
            </ListItem>
          ) : null
        }

      <ListItem color="black">
        <ListItemLink to={`mailto:${SITE_EMAIL}`} target="_blank">
          <MdOutlineAlternateEmail /> <span>{SITE_EMAIL}</span>
        </ListItemLink>
      </ListItem>
    </List>
  );
};

export default ReportErrorContact;
